"use client";
import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const cardVariants = cva(
  'rounded-lg bg-white transition-all duration-200',
  {
    variants: {
      variant: {
        default: 'border border-neutral-200 shadow-sm hover:shadow-md hover:-translate-y-1',
        elevated: 'border border-neutral-200 shadow-md hover:shadow-lg hover:-translate-y-1',
        outlined: 'border-2 border-neutral-300 shadow-none hover:border-[color:var(--color-primary)] hover:shadow-md',
        flat: 'border border-neutral-100 shadow-none',
      },
      padding: {
        none: '',
        sm: 'p-4',
        default: 'p-6',
        lg: 'p-8',
      },
    },
    defaultVariants: {
      variant: 'default',
      padding: 'none',
    },
  }
);

export interface CardProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof cardVariants> {}

export function Card({ className, variant, padding, ...props }: CardProps) {
  return (
    <div className={cn(cardVariants({ variant, padding }), className)} {...props} />
  );
}

export function CardHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-6 border-b border-neutral-200', className)} {...props} />;
}

export function CardContent({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-6', className)} {...props} />;
}

export function CardFooter({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-6 border-t border-neutral-200', className)} {...props} />;
}
